export enum ProjectId {
  Upwealth = '50993743',
  Morpheus = '146691194',
  Sentr3 = '146685417',
  FallsPay = '146468420',
  OhanaLink = '24218964',
  WhaleRoom = '51628899',
  BFast = '50513003',
  WorkAxle = '22415034',
  NetworkOS = '24220186',
  Synchronos = '22415037',
  BitFinance = '24220177',
  LbRMgR = '24288723',
  Creator = '24288616',
  FantasyInsiders = '24288528',
  Voicereel = '24288346',
  Lyfta = '24288315',
  Tazawaj = '24317208',
  Guided = '24311415',
  OvrPass = '24288975',
  DMI = '55515843',
  SappChat = '87642379',
  FuturWise = 'cVxVYOYtQbesKj2y3ZbwbQ',
  EmajinGolf = 'amfVpQ76Q-6cEHucP1B7GQ',
}

export enum Tags {
  AI = 'AI',
  API = 'API',
  Automation = 'Automation',
  Blockchain = 'Blockchain',
  Design = 'Design',
  Mobile = 'Mobile',
  Research = 'Research',
  Web = 'Web',
}
